import { useCallback } from "react"
import { useAppDispatch } from "../../../../store/hooks"
import { searchArticles } from "../../../../store/knowledgeBase/thunks"
import { SearchArticlesInputLogic } from "../Logic"
import { SearchArticlesRequest } from "../../../../models/article"
import { ItemId } from "../../../../models/category"
import { CommonSearchArticlesInputProps } from "../.."

export interface SearchArticlesInputContainerProps extends CommonSearchArticlesInputProps {
    allowedCatalogs?: ItemId[]
    projectId: string
}

export const SearchArticlesInputContainer = (props: SearchArticlesInputContainerProps) => {
    const { allowedCatalogs, projectId, ...rest } = props
    const dispatch = useAppDispatch()

    const handleSearch = useCallback(
        (request: SearchArticlesRequest) => {
            if (projectId && (!request.Text || request.Text.length > 2)) {
                dispatch(searchArticles(projectId, { ...request, AllowedCatalogsCodes: allowedCatalogs }))
            }
        },
        [projectId, dispatch]
    )

    return <SearchArticlesInputLogic onSearch={handleSearch} {...rest} />
}
